import { render } from "./MetricsTable.vue?vue&type=template&id=54ee4e5a&scoped=true"
import script from "./MetricsTable.vue?vue&type=script&lang=js"
export * from "./MetricsTable.vue?vue&type=script&lang=js"

import "./MetricsTable.vue?vue&type=style&index=0&id=54ee4e5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ee4e5a"]])

export default __exports__